<script>
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import TolaSignal from 'dashboard/components-next/empty-state/TolaSignal.vue';

export default {
  components: {
    Spinner,
    TolaSignal,
  },
  props: {
    emptyStateMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'notifications/getUIFlags',
    }),
    emptyMessage() {
      if (this.emptyStateMessage) {
        return this.emptyStateMessage;
      }
      return this.$t('INBOX.LIST.NOTE');
    },
  },
};
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full p-6 text-center bg-n-surface-2 lg:flex"
  >
    <div
      v-if="uiFlags.isFetching"
      role="status"
      aria-busy="true"
      class="flex flex-col items-center justify-center gap-3 my-4 text-sm text-n-slate-11"
    >
      <Spinner class="text-n-brand" />
      {{ $t('INBOX.LIST.LOADING') }}
    </div>
    <div
      v-else
      class="flex flex-col items-center max-w-sm gap-3 p-8 border shadow-sm rounded-2xl border-n-weak bg-n-solid-2"
    >
      <TolaSignal icon="i-lucide-messages-square" />
      <div>
        <h2 class="m-0 text-heading-2 text-n-slate-12">
          {{ $t('INBOX.WORKSPACE.EMPTY.SELECT_TITLE') }}
        </h2>
        <p class="mt-1 mb-0 text-sm text-n-slate-11">
          {{ emptyMessage }}
        </p>
      </div>
      <span
        class="items-center hidden gap-2 mt-1 text-xs text-n-slate-9 xl:flex"
      >
        <kbd
          class="px-1.5 py-0.5 font-sans border rounded-md border-n-weak bg-n-alpha-2 text-n-slate-10"
        >
          {{ $t('INBOX.WORKSPACE.KEYS.ARROWS') }}
        </kbd>
        {{ $t('INBOX.WORKSPACE.EMPTY.KEYBOARD_DETAIL') }}
      </span>
    </div>
  </div>
</template>
